import editableAutocomplete from "./editableAutocomplete.component";

const editableAutocompleteModule = angular
  .module("app.components.editableAutocomplete", [])
  .component("editableAutocomplete", editableAutocomplete);

export default editableAutocompleteModule;



// WEBPACK FOOTER //
// ./src/components/editableAutocomplete/editableAutocomplete.module.js